var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SectorButton from '../projects/SectorButton.vue';
import ArticleInfo from '../articles/ArticleInfo.vue';
import Pager from '../shared/Pager.vue';
import Loader from '../shared/Loader.vue';
import SocialLink from '../shared/SocialLink.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let ArticlesList = class ArticlesList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.noResult = false;
        this.data = [];
        this.pageLoading = false;
        this.activeSectorId = 0;
        this.currentPage = new URLSearchParams(window.location.search).get('page') ? Number(new URLSearchParams(window.location.search).get('page')) : 1;
        this.numberOfPage = 0;
        this.itemPerPage = 5;
        this.args = {};
        this.filterSelect = null;
        this.yearSelect = null;
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: '',
        };
    }
    get topArticles() {
        if (this.data && this.data.length > 0) {
            return this.data.slice(0, 3);
        }
        return [];
    }
    created() {
        this.args = {
            siteId: window.cibbic.siteId,
            relatedToCategories: this.activeSector ? this.activeSector.id : null,
            offset: new URLSearchParams(window.location.search).get('page') ? ((Number(new URLSearchParams(window.location.search).get('page'))) - 1) * this.itemPerPage : 0
        };
        this.getArticles(this.args);
        if (this.activeSector) {
            this.activeSectorId = this.activeSector.id;
        }
    }
    mounted() {
        this.selectProps.noResultsText = this.labels.noResultsText;
        this.selectProps.noChoicesText = this.labels.noChoicesText;
        this.filterSelect = new Choices('#sectorFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'sectorFilterLabel' }));
        this.yearSelect = new Choices('#yearFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'yearFilterLabel' }));
        if (this.sectors.length > 0) {
            this.fillSectorsDropDown();
        }
    }
    getImage(article, size) {
        if (article.teaserImage[0]) {
            return article.teaserImage[0][size];
        }
        if (article.image[0]) {
            return article.image[0][size];
        }
        return null;
    }
    getImageAlt(article) {
        if (article.teaserImage[0]) {
            return article.teaserImage[0].altText;
        }
        if (article.image[0]) {
            return article.image[0].altText;
        }
    }
    getSectorString(sectors) {
        return sectors.map((s) => { return s.title; }).join(' | ');
    }
    onSectorClicked(sector) {
        if (sector) {
            window.location.href = sector.url;
        }
        else if (this.activeSectorId != 0) {
            window.location.href = this.overviewUrl;
        }
    }
    onPageChange(value) {
        this.pageLoading = true;
        this.currentPage = value;
        this.args.offset = (value - 1) * this.itemPerPage;
        this.getArticles(this.args);
    }
    onYearFilterChanged(evt) {
        this.pageLoading = true;
        this.args.year = evt.detail.value;
        this.getArticles(this.args);
    }
    onSectorFilterChanged(evt) {
        if (evt.detail.value === 0) {
            this.onSectorClicked(null);
        }
        else {
            let sector = this.sectors.find((s) => { return s.id === evt.detail.value; });
            this.onSectorClicked(sector);
        }
    }
    fillSectorsDropDown() {
        var _a;
        let tmp = this.sectors.map((i) => {
            return { value: i.id, label: i.title, selected: this.activeSectorId == i.id };
        });
        tmp.unshift({ value: 0, label: this.labels.all_sectors, selected: this.activeSectorId === 0 });
        (_a = this.filterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(tmp, 'value', 'label', true);
    }
    fillYearDropDown() {
        var _a;
        let last = parseInt(this.articlesData.last[0].postDate);
        let first = parseInt(this.articlesData.first[0].postDate);
        let years = [];
        let current = first;
        while (last <= current) {
            years.push({ value: current, label: current });
            current--;
        }
        years.unshift({ value: 0, label: this.labels.all, selected: true });
        (_a = this.yearSelect) === null || _a === void 0 ? void 0 : _a.setChoices(years, 'value', 'label', true);
    }
    onArticlesData(value) {
        this.noResult = false;
        this.data = this.articlesData.articles || [];
        if (this.data.length > 0) {
            this.numberOfPage = Math.ceil(this.itemCount / this.itemPerPage);
            setTimeout(() => {
                this.pageLoading = false;
                window.cibbic.lazyLoadInstance.update();
            }, 100);
            if (window.scrollY > 0) {
                document.querySelector('#articles-list-component').scrollIntoView({
                    behavior: "smooth",
                });
            }
            if (this.args.year === undefined) {
                this.fillYearDropDown();
            }
        }
        else if (this.data.length === 0 && this.articlesData.articles !== undefined) {
            this.pageLoading = false;
            this.noResult = true;
        }
    }
    onSectors() {
        this.fillSectorsDropDown();
        this.loading = false;
    }
};
__decorate([
    Prop({ type: Object })
], ArticlesList.prototype, "labels", void 0);
__decorate([
    Prop({ type: Object })
], ArticlesList.prototype, "activeSector", void 0);
__decorate([
    Prop()
], ArticlesList.prototype, "overviewUrl", void 0);
__decorate([
    service.State
], ArticlesList.prototype, "articlesData", void 0);
__decorate([
    service.State
], ArticlesList.prototype, "sectors", void 0);
__decorate([
    service.State
], ArticlesList.prototype, "itemCount", void 0);
__decorate([
    service.Action
], ArticlesList.prototype, "getArticles", void 0);
__decorate([
    Watch('articlesData')
], ArticlesList.prototype, "onArticlesData", null);
__decorate([
    Watch('sectors')
], ArticlesList.prototype, "onSectors", null);
ArticlesList = __decorate([
    Component({
        components: {
            SectorButton,
            ArticleInfo,
            Pager,
            Loader,
            SocialLink
        }
    })
], ArticlesList);
export default ArticlesList;
